import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ProfilesFacadeService} from "../profiles-facade.service";
import {Observable} from "rxjs";
import {Profile} from "@model/profile";
import {ProfileItemComponent} from '../profile-item/profile-item.component';
import {AsyncPipe} from '@angular/common';
import {MatListModule} from '@angular/material/list';
import {MatCardModule} from '@angular/material/card';
import {HorizonProfileToolbarComponent} from 'src/app/app-layout/horizon-profile-toolbar/horizon-profile-toolbar.component';

@Component({
    selector: 'app-profile-root',
    templateUrl: './profile-root.component.html',
    styleUrls: ['./profile-root.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatCardModule, MatListModule, ProfileItemComponent, AsyncPipe, HorizonProfileToolbarComponent]
})
export class ProfileRootComponent implements OnInit {

  profiles$: Observable<Profile[]>;

  constructor(private _profileFacade: ProfilesFacadeService) { }

  ngOnInit() {
    this.profiles$ = this._profileFacade.profiles$;
  }

  selectProfile(profile: Profile) {
    this._profileFacade.selectProfile(profile);
  }

  logout() {
    this._profileFacade.logout();
  }
}
